const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfileDetails = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7 0 C 3.140625 0 0 3.140625 0 7 C 0 10.859375 3.140625 14 7 14 C 10.859375 14 14 10.859375 14 7 C 14 3.140625 10.859375 0 7 0 Z M 7 13.390625 C 3.476562 13.390625 0.609375 10.523438 0.609375 7 C 0.609375 3.476562 3.476562 0.609375 7 0.609375 C 10.523438 0.609375 13.390625 3.476562 13.390625 7 C 13.390625 10.523438 10.523438 13.390625 7 13.390625 Z M 7 13.390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7 6.695312 C 4.820312 6.695312 3.042969 8.46875 3.042969 10.652344 C 3.042969 10.820312 3.179688 10.957031 3.347656 10.957031 C 3.515625 10.957031 3.652344 10.820312 3.652344 10.652344 C 3.652344 8.804688 5.152344 7.304688 7 7.304688 C 8.847656 7.304688 10.347656 8.804688 10.347656 10.652344 C 10.347656 10.820312 10.484375 10.957031 10.652344 10.957031 C 10.820312 10.957031 10.957031 10.820312 10.957031 10.652344 C 10.957031 8.46875 9.179688 6.695312 7 6.695312 Z M 7 6.695312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7 1.824219 C 5.824219 1.824219 4.871094 2.78125 4.871094 3.957031 C 4.871094 5.132812 5.824219 6.085938 7 6.085938 C 8.175781 6.085938 9.128906 5.132812 9.128906 3.957031 C 9.128906 2.78125 8.175781 1.824219 7 1.824219 Z M 7 5.476562 C 6.160156 5.476562 5.476562 4.796875 5.476562 3.957031 C 5.476562 3.117188 6.160156 2.433594 7 2.433594 C 7.839844 2.433594 8.523438 3.117188 8.523438 3.957031 C 8.523438 4.796875 7.839844 5.476562 7 5.476562 Z M 7 5.476562 "
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfileDetails);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile-details.051fa9e2cfed613dbf3491024068c518.svg";